import {
	Component,
	OnInit
} from '@angular/core';
import {
	ActivatedRoute,
	Router
} from "@angular/router";
import {environment} from "../../../environments/environment";
import {forkJoin} from "rxjs";
import {LPService} from "../../shared/services/lp.service";
import {AppConfigService} from "../../shared/services/config/app-config.service";

@Component({
	selector: 'app-card-detail',
	templateUrl: './card-detail.component.html',
	styleUrls: ['./card-detail.component.scss']
})
export class CardDetailComponent implements OnInit {

	loanPurpose: string | null = null;
	product: string | null = '';
	cardName: string | null = '';
	cardDetail: any = null;
	merchantId: string | null = null;
    disclosureUrl = '';
	ccRatesLookup: any[] = [];
	offerVariationDetails: any;
	subProductRatesLookup: any;
	processingLink = false;
	appConfig = AppConfigService.config;
	replaceContext: Record<string, any> = {};

	constructor(private activatedRoute: ActivatedRoute,
		private router: Router,
		private lpService: LPService) {
	}

	ngOnInit() {
		this.activatedRoute.queryParams.subscribe(params => {
			console.log(params, "params - in card list");
			this.merchantId = params['merchantId'];
		});

		this.activatedRoute.paramMap.subscribe(params => {
			this.loanPurpose = params.get('loanPurpose');
			this.product = this.loanPurpose?.startsWith("BCC") ? "BUSINESS_CREDIT_CARD" : "CREDIT_CARD";
			this.cardName = params.get('cardName');

			if (this.loanPurpose && this.cardName) {
                this.disclosureUrl = `/disclosures/${this.loanPurpose}/${this.cardName}?merchantId=${this.merchantId}`;
				this.cardDetail = this.appConfig[this.loanPurpose].offerVariationDetails[this.cardName];
				if (!this.cardDetail) {
					this.router.navigate(['/']);
				} else {
					this.cardDetail.imageUrl = `${environment.s3Url}images/${environment.institutionCode}/${this.merchantId}_${this.cardName}.png` || this.cardDetail.imageUrl;
					this.cardDetail.tcUrl = `${environment.s3Url}html/${environment.institutionCode}/${this.cardName.toLowerCase()}_tc.html`;
				}
			} else {
				this.router.navigate(['/']);
			}
		});

		this.getRatesDetails();
	}

	getRatesDetails() {

		const ratesLookupAPIs = [];

		ratesLookupAPIs.push(this.lpService.getRatesDetails(this.loanPurpose, this.cardName, this.product));

		ratesLookupAPIs.push(this.lpService.getRatesLookup());

		// Make the HTTP request with the authorization header
		forkJoin(ratesLookupAPIs).subscribe({
			next: (response: any) => {
				this.ccRatesLookup = response[1].offerVariationDetails;
				// this.subProductRatesLookup = response[0].offerRatesLookupVOList;

				this.subProductRatesLookup = this.ccRatesLookup.find(lookup => Number(lookup.offerVariationDetailsId) === Number(response[0].offerRatesLookupVOList[0].offerVariationDetailsId));
				this.subProductRatesLookup = {...response[0].offerRatesLookupVOList[0], ...this.subProductRatesLookup}

				this.subProductRatesLookup = {
					...this.subProductRatesLookup,
					...response[0].offerRatesLookupVOList.reduce((rateLookup: any, obj: any) => {
						if (Number(obj.purchaseAPR) < rateLookup.minPurchaseAPR) rateLookup.minPurchaseAPR = Number(obj.purchaseAPR);
						if (Number(obj.purchaseAPR) > rateLookup.maxPurchaseAPR) rateLookup.maxPurchaseAPR = Number(obj.purchaseAPR);
						if (Number(obj.cashAdvanceAPR) < rateLookup.minCashAdvanceAPR) rateLookup.minCashAdvanceAPR = Number(obj.cashAdvanceAPR);
						if (Number(obj.cashAdvanceAPR) > rateLookup.maxCashAdvanceAPR) rateLookup.maxCashAdvanceAPR = Number(obj.cashAdvanceAPR);
						if (Number(obj.balanceTransferAPR) < rateLookup.minBalanceTransferAPR) rateLookup.minBalanceTransferAPR = Number(obj.balanceTransferAPR);
						if (Number(obj.balanceTransferAPR) > rateLookup.maxBalanceTransferAPR) rateLookup.maxBalanceTransferAPR = Number(obj.balanceTransferAPR);
						return rateLookup;
					}, {
						minBalanceTransferAPR: 999,
						maxBalanceTransferAPR: 0,
						minPurchaseAPR: 999,
						maxPurchaseAPR: 0,
						minCashAdvanceAPR: 999,
						maxCashAdvanceAPR: 0
					})
				}
				// Show exact APR when min and max same otherwise show range
				this.subProductRatesLookup.purchaseAPRDisplay = this.subProductRatesLookup.minPurchaseAPR === this.subProductRatesLookup.maxPurchaseAPR ? Number(this.subProductRatesLookup.maxPurchaseAPR).toFixed(2) : `${Number(this.subProductRatesLookup.minPurchaseAPR).toFixed(2)}% - ${Number(this.subProductRatesLookup.maxPurchaseAPR).toFixed(2)}%`;
				this.subProductRatesLookup.cashAdvanceAPRDisplay = this.subProductRatesLookup.minCashAdvanceAPR === this.subProductRatesLookup.maxCashAdvanceAPR ? Number(this.subProductRatesLookup.maxCashAdvanceAPR).toFixed(2) : `${Number(this.subProductRatesLookup.minCashAdvanceAPR).toFixed(2)}% - ${Number(this.subProductRatesLookup.maxCashAdvanceAPR).toFixed(2)}%`
				this.subProductRatesLookup.balanceTransferAPRDisplay = this.subProductRatesLookup.minBalanceTransferAPR === this.subProductRatesLookup.maxBalanceTransferAPR ? Number(this.subProductRatesLookup.maxBalanceTransferAPR).toFixed(2) : `${Number(this.subProductRatesLookup.minBalanceTransferAPR).toFixed(2)}% - ${Number(this.subProductRatesLookup.maxBalanceTransferAPR).toFixed(2)}%`
                if (this.subProductRatesLookup.annualFee) {
                    this.subProductRatesLookup.annualFee = Number(this.subProductRatesLookup.annualFee).toFixed(2);
                }
				console.log('subProductRatesLookup >>>>>>>>>>',this.subProductRatesLookup);
				this.buildReplaceContext();
				// if (response && response.offerRatesLookupVOList && response.offerRatesLookupVOList.length > 0) {
				//     //   this.setCreditCards(response);
				//     console.log(response)
				// }
			},
			error: (error) => {
				console.error('Error:', error);
			}
		})
		;
	}

	gotoCXUrl() {
		if (this.merchantId) {
			let url = `${environment.cxUrl}/product/${this.loanPurpose}?merchantId=${this.merchantId}`;
			window.open(url, "_blank");
		}
	}
	private buildReplaceContext(): void {
		this.replaceContext = {
			...(this.subProductRatesLookup || {}),
			disclosureUrl: this.disclosureUrl
		};
	}
	applyByEmail() {
		this.processingLink = true;
		this.lpService.getApplyByMailLink(this.merchantId, this.cardName).subscribe({
			next: (response: any) => {
				if (response.pdfApplication) {
					const byteCharacters = atob(response.pdfApplication);
					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					const byteArray = new Uint8Array(byteNumbers);
					const blob = new Blob([byteArray], { type: 'application/pdf' });
					const blobUrl = URL.createObjectURL(blob);
					window.open(blobUrl, "_blank");
				} else if (response.url) {
					window.open(response.url, "_blank");
				}
			},
			error: (error) => {
				console.error('Error:', error);
			},
			complete: () => {
				this.processingLink = false;
			}
		})
	}
}
